// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const VERIFIED_ORGANIZATION_BADGE = "Overen\u00e1 organiz\u00e1cia";
